import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('@/views/menu/index'),
    children: [
      // 首页
      {
        path: '/home',
        component: () => import('@/views/home/home')
      },
      // 敬请期待
      {
        path: '/expect',
        component: () => import('@/views/home/expect')
      },
      {
        path: '/expect1',
        component: () => import('@/views/home/expect1')
      },
      {
        path: '/expect2',
        component: () => import('@/views/home/expect2')
      },
      {
        path: '/expect3',
        component: () => import('@/views/home/expect3')
      },
      {
        path: '/expect4',
        component: () => import('@/views/home/expect4')
      },
      {
        path: '/expect5',
        component: () => import('@/views/home/expect5')
      },
      // 网络空间资产测绘分析系统
      {
        path: '/camas',
        component: () => import('@/views/safetyProducts/camas')
      },
      // 安全运营管理系统
      {
        path: '/nsomp',
        component: () => import('@/views/safetyProducts/nsomp')
      },
      // 网络安全教培平台
      {
        path: '/nsetp',
        component: () => import('@/views/safetyProducts/nsetp')
      },
      // 网络应急工具箱
      {
        path: '/nsep',
        component: () => import('@/views/safetyProducts/nsep')
      },
      // 风险评估
      {
        path: '/risk',
        component: () => import('@/views/securityServices/risk')
      },
      // 渗透测试
      {
        path: '/seep',
        component: () => import('@/views/securityServices/seep')
      },
      // 安全检查
      {
        path: '/inspect',
        component: () => import('@/views/securityServices/inspect')
      },
      // 代码审计
      {
        path: '/audit',
        component: () => import('@/views/securityServices/audit')
      },
      // 安全意识培训服务
      {
        path: '/realize',
        component: () => import('@/views/securityServices/realize')
      },
      // 行业安全咨询
      {
        path: '/sector',
        component: () => import('@/views/securityServices/sector')
      },
      // 安全体系规划设计服务
      {
        path: '/planning',
        component: () => import('@/views/securityServices/planning')
      },
      // 安全技术培训
      {
        path: '/training',
        component: () => import('@/views/securityServices/training')
      },
      // 安全监测
      {
        path: '/monitor',
        component: () => import('@/views/securityServices/monitor')
      },
      // 安全巡检服务
      {
        path: '/inspection',
        component: () => import('@/views/securityServices/inspection')
      },
      // 安全通告
      {
        path: '/notify',
        component: () => import('@/views/securityServices/notify')
      },
      // 重保值守服务
      {
        path: '/guardAgain',
        component: () => import('@/views/securityServices/guardAgain')
      },
      // 应急响应服务
      {
        path: '/emergency',
        component: () => import('@/views/securityServices/emergency')
      },

      // 安全运营服务
      {
        path: '/safeOperation',
        component: () => import('@/views/security/safeOperation')
      },
      // 攻防演练
      {
        path: '/attackDrill',
        component: () => import('@/views/security/attackDrill')
      },

      // 解决方案
      // 等级保护建设方案
      {
        path: '/gradeProtection',
        component: () => import('@/views/solution/protectionGrade')
      },
      // 数据安全解决方案

      // 政府
      {
        path: '/government',
        component: () => import('@/views/solution/government')
      },

      // 医疗
      {
        path: '/medicalCare',
        component: () => import('@/views/solution/medicalTreatment')
      },
      // 企业
      {
        path: '/enterprise',
        component: () => import('@/views/solution/enterprise')
      },
      // 关键基础设施
      {
        path: '/infrastructure',
        component: () => import('@/views/solution/baseInstallation')
      },

      // // 金融
      // {
      //   path: '/finance',
      //   component: () => import('@/views/solution/finance')
      // },
      // 教育
      // {
      //   path: '/education',
      //   component: () => import('@/views/solution/education')
      // },

      // 数据安全解决方案
      {
        path: '/dataSecurity',
        component: () => import('@/views/solution/Security')
      },
      // 监管单位
      {
        path: '/supervisionUnit',
        component: () => import('@/views/solution/supervisionUnit')
      },
      // 系统安全加固方案
      {
        path: '/systemSecurityReinforcement',
        component: () => import('@/views/solution/systemSecurityReinforcement')
      },
      // 主机安全加固方案
      {
        path: '/hostSecurityReinforcement',
        component: () => import('@/views/solution/hostSecurityReinforcement')
      },
      // 终端一体化解决方案
      {
        path: '/terminalIntegration',
        component: () => import('@/views/solution/terminalIntegration')
      },
      // 安全运营解决方案简约版
      {
        path: '/simpleVersionOfSafeOperation',
        component: () => import('@/views/solution/SafeOperation')
      },
      {
        path: '/noConstructor',
        component: () => import('@/views/solution/noConstructor')
      },
      // 跨网交换解决方案
      {
        path: '/crossNetworkSwitching',
        component: () => import('@/views/solution/crossNetworkSwitching')
      },
      // 全流量安全监测分析服务解决方案
      {
        path: '/fullFlowSafety',
        component: () => import('@/views/solution/fullFlowSafety')
      },
      // 关于我们
      {
        path: '/synopsis', // 公司简介
        component: () => import('@/views/aBoutus/synopsis')
      },
      // {
      //   path: '/recruit', // 英才招聘
      //   component: () => import('@/views/aBoutus/recruit')
      // },
      {
        path: '/contact', // 联系我们
        component: () => import('@/views/aBoutus/contact')
      },
      {
        path: '/news', // 联系我们
        component: () => import('@/views/aBoutus/news')
      },
      {
        path: '/emergencyToolbox',
        component: () => import('@/views/production/emergency')
      },
      {
        path: '/port',
        component: () => import('@/views/production/port')
      },
      {
        path: '/verb',
        component: () => import('@/views/production/verb')
      },
      {
        path: '/maintain',
        component: () => import('@/views/production/maintain')
      },
      {
        path: '/camasPro',
        component: () => import('@/views/production/camas')
      },
      {
        path: '/safe',
        component: () => import('@/views/production/safe')
      },
      {
        path: '/informationization',
        component: () => import('@/views/production/informationization')
      },
      {
        path: '/auto',
        component: () => import('@/views/production/auto')
      },
      {
        path: '/sup',
        component: () => import('@/views/support/support')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router
